import { Notes } from './';

import { CellItem } from 'vue/types/vue';
import { Note } from './note';

export class WordStart
{
    public x: number;
    public y: number;

    constructor(x: number = -1, y: number = -1)
    {
        this.x = x;
        this.y = y;
    }

    setX(x: number): void
    {
        this.x = x;
    }
    setY(y: number): void
    {
        this.y = y;
    }
    getX(): number
    {
        return this.x;
    }
    getY(): number
    {
        return this.y;
    }
}

export class PuzzleData
{

    public puzzleName: string;
    public puzzleid: string = "";
    public state: string[][] = [];
    public wordStarts: WordStart[] = [];
    public arrows: CellItem[] = [];
    public dashes: CellItem[] = [];
    public viewSolution: boolean;
    public notes: Note[] = new Array<Note>();
    

    constructor(puzzleName: string = "", canViewSolution: boolean = false)
    {
        this.puzzleName = puzzleName;
        this.viewSolution = canViewSolution;
    }

    public setState(state: string[][]): void
    {
        this.state = state;
    }
    public setId(id: string): void
    {
        this.puzzleid = id;
    }
    public setWordStarts(wordStarts: WordStart[]): void 
    {
        this.wordStarts = wordStarts;
    }
    public setArrows(arrows: CellItem[]): void
    {
        this.arrows = arrows;
    }
    public setDashes(dashes: CellItem[]): void
    {
        this.dashes = dashes;
    }
    public getId(): string
    {
        return this.puzzleid;
    }

    public canViewSolution(): boolean
    {
        return this.viewSolution;
    }
    public getWidth(): number
    {
        return this.state[0].length;
    }
    public getHeight(): number
    {
        return this.state.length;
    }
    public setNotes(notes: Note[]): void {
        this.notes = notes;
    }
    public getNotes(): Note[] {
        return this.notes;
    }
    

}